import React from 'react';
import { Node } from '../../autogenerated/ZoomBridge';
import './BrowseExtChild.css';
import BrowseExtParent from './BrowseExtParent';
type browseExtChildProps = {
  node: Node,
  bucketName: string
};
function BrowseExtChild(props: browseExtChildProps) {
  const { node } = props;
  const childNodes: Array<Node> = node.getChildNodes();
  return (
    <div name="BrowseExtChild" className="flex-col">
      {childNodes
        ? childNodes.map((node, index) => {
            return (
              <BrowseExtParent
                parent_key={node.getKey()}
                childNode={node}
                key={index}
                type={node.getType()}
                bucketName={props.bucketName}></BrowseExtParent>
            );
          })
        : null}
    </div>
  );
}

export default BrowseExtChild;
